/* template */
<template minapp="mpx" xlang="wxml"><contact-dialog :show="(show)" title="确认购买学生票？" subTitle="乘客类型为学生票" confirmText="购买成人票" cancelText="购买学生票" @cancel="cancelContactDialog" @confirm="confirmContactDialog"><div class="inner-box"><div class="inner-text">·学生一年仅能购买4次优惠区间的列车</div><div class="inner-text">·超过4次优惠或购买不在优惠区间的将无法取票(可能需要补差价)</div></div></contact-dialog></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5acbaaa8"}'>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 24px 0
    border-radius 8px
    .inner-text
      margin-top 4px
      &:first-child
        margin-top 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5acbaaa8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./student-confirm-dialog.mpx.js?isComponent&outputPath=components%2Fstudent-confirm-dialog5acbaaa8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./student-confirm-dialog.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fstudent-confirm-dialog5acbaaa8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5acbaaa8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/student-confirm-dialog5acbaaa8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'contact-dialog':getComponent(require("./index.mpx?isComponent&outputPath=components%2Findexd3416d8a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
